export enum TaskType {
    ExtraDetails = "extra-details",
    MewozMunicipalityCheck = "mewoz-municipality-check",
    ObjectionOutcome = "objection-outcome",
    ObjectionSubmitted = "objection-submitted",
    PhoneNumberMissing = "phone-number-missing",
    Photo = "photo",
    Payment = "payment-request",
    PoaMissing = "poa-missing",
    Reapply = "reapply",
    ValuationFinal = "valuation-final",
    WozCheckCompleted = "woz-check-completed",
    WozCheckNextYear = "woz-check-next-year",
    WozKnown = "woz-known",
    WozUnknown = "woz-unknown",
}

export enum SocialPlatform {
    Facebook = "facebook",
    Google = "google",
}

export enum SocialPlatformToken {
    FacebookToken = "facebook-token",
    GoogleToken = "google-token",
}

export enum SectionType {
    ObjectType = "object-type",
}
